import React from 'react';
export function Footer() {
  return <footer id="contact" className="bg-slate-950 text-slate-400 py-12 border-t border-slate-800" data-id="element-10" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11" data-mp="3ghc508vl1fre">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-12" data-mp="32p5nojgp12qd">
          <div data-id="element-13" data-mp="36oxzd51dvozy">
            <h2 className="text-2xl font-bold text-white tracking-tighter mb-4" data-id="element-14" data-mp="36oo5h6d7wxoz">
              TWICEBOURNE
            </h2>
            <p className="text-sm max-w-xs" data-id="element-15" data-mp="3ufju5umdncs0">
              A diverse portfolio of premium brands delivering excellence across
              real estate, entertainment, apparel, and hospitality.
            </p>
          </div>

          <div data-id="element-16" data-mp="3lgop4lv2k8qa">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-17" data-mp="3qdf75eqfpeec">
              Our Brands
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-18" data-mp="29zgnu9fpz8qc">
              <li data-id="element-19" data-mp="29xm1qrsppako">
                <a href="#" className="hover:text-white transition-colors" data-id="element-20" data-mp="2a19qzer4jatl">
                  Saint Lucia
                </a>
              </li>
              <li data-id="element-21" data-mp="3l8qwa43iojrg">
                <a href="#" className="hover:text-white transition-colors" data-id="element-22" data-mp="3labrlvxno6qd">
                  Barndormitory Holdings LLC
                </a>
              </li>
              <li data-id="element-23" data-mp="3v7ggi3ivygav">
                <a href="#" className="hover:text-white transition-colors" data-id="element-24" data-mp="3v7zvbbd8ooko">
                  Entertainment Films
                </a>
              </li>
              <li data-id="element-25" data-mp="3qapwx67vh2kp">
                <a href="#" className="hover:text-white transition-colors" data-id="element-26" data-mp="82qsbsqetttq">
                  Apparels
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-27" data-mp="31uo1e25c5ns">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-28" data-mp="hstuaifiei47">Contact</h3>
            <ul className="space-y-2 text-sm" data-id="element-29" data-mp="huwicwx3q16a">
              <li data-id="element-30" data-mp="ctgwx3r0hsnd">contact@twicebourne.com</li>
              <li data-id="element-31" data-mp="cuiii25nlxjc">1-800-TWICE-BRN</li>
              <li data-id="element-32" data-mp="qt8fziwdxz88">Global Headquarters</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-33" data-mp="mrwqrehfbg0k">
          <p data-id="element-34" data-mp="tvw6yepkdbex">
            &copy; {new Date().getFullYear()} TwiceBourne. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-35" data-mp="yv93xsa5fyv8">
            <a href="#" className="hover:text-white transition-colors" data-id="element-36" data-mp="ys3gsil2z725">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-37" data-mp="18k0srrjwy31x">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}